import './TestimonialsSection.css';

const TestimonialsSection = () => {
    return (
        <section className="basic-area testimonials-section">
            <div className="container">
                <h2 className="testimonials-title">
                    What Our Customers Say
                </h2>
                <div className="testimonials-grid">
                    {/* Testimonial 1 */}
                    <div className="testimonial-card">
                        <div className="testimonial-quote-mark">"</div>
                        <p className="testimonial-text">
                            Katalife has given us insight into areas we can improve that we never knew about before. The setup was super quick and easy, and our customers love the simplicity of the feedback process. Highly recommend!
                        </p>
                        <div className="testimonial-attribution">
                            <div className="testimonial-name">Andrew</div>
                            <div className="testimonial-position">Owner, Northern Bean Cafe, Australia</div>                            
                        </div>
                    </div>

                    {/* Testimonial 2 */}
                    <div className="testimonial-card">
                        <div className="testimonial-quote-mark">"</div>
                        <p className="testimonial-text">
                            As a busy restaurant owner, I needed something quick and easy. Katalife delivers exactly that. Setup took 2 minutes, and now we get real-time feedback that helps us improve daily. 
                        </p>
                        <div className="testimonial-attribution">
                            <div className="testimonial-name">Sagar</div>
                            <div className="testimonial-position">Owner, Saffron Urban Kitchen, Omaha, USA</div>                            
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default TestimonialsSection;
